import { render, staticRenderFns } from "./PresenceReport.vue?vue&type=template&id=a24d4e02"
import script from "./PresenceReport.vue?vue&type=script&lang=js"
export * from "./PresenceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports